import React from "react";
import "./GetMusicOnBeep.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnBeep = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload music & artwork",
    "Select BEEP distribution",
    "Release approved by stores",
    "Go live worldwide",
    "Track streams & royalties"
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Your Music on BEEP | Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to BEEP with FT Tunes. Reach new listeners worldwide and grow your audience with fast global distribution."
        />

        <meta
          name="keywords"
          content="BLEEP distribution, upload music to BEEP, music distribution platform, FT Tunes"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="beep-page">

        {/* HERO */}
        <section className="beep-hero">
          <Container>

            <img
              src="/Images/beep-logo.png"
              alt="BLEEP Distribution"
              className="beep-logo"
            />

            <h1>Get Your Music on BEEP</h1>

            <p>
              Distribute your music to BLEEP and connect with a growing
              global audience. Expand your reach, increase streams,
              and build your music career worldwide.
            </p>

            <Button
              className="gradient-btn-beep"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-beep"></div>
        </section>


        {/* SHOWCASE */}
        <section className="beep-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach New Music Audiences</h2>

                <p>
                  BLEEP helps independent artists distribute music faster
                  and reach listeners across emerging digital markets.
                  Publish releases easily and grow your fanbase.
                </p>

                <Button
                  className="outline-btn-beep"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-beep.png"
                  alt="BLEEP Platform"
                  className="beep-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="beep-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-beep">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="beep-benefits">
          <Container>

            <h2 className="section-title">
              Why Artists Choose BLEEP
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-beep">
                  <h5>Global Reach</h5>
                  <p>Connect with listeners worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-beep">
                  <h5>Fast Distribution</h5>
                  <p>Release music quickly to audiences.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-beep">
                  <h5>Artist Control</h5>
                  <p>You keep full ownership rights.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-beep">
                  <h5>Royalty Tracking</h5>
                  <p>Monitor streams & earnings easily.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="beep-cta">
          <Container>

            <h2>Release Your Music on BLEEP Today</h2>

            <Button
              className="gradient-btn-beep big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnBeep;